import React from 'react'
import { useLocation } from '@reach/router'
import CognigyChatInitializer from './CognizyChatInitializer'
import { useTheme } from '@mui/material/styles'
import { GlobalStyles } from '@mui/system'

export default function ChatManager() {
  const { breakpoints } = useTheme()
  const location = useLocation()
  const globalStyles = (
    <GlobalStyles
      styles={{
        [breakpoints.down('md')]: {
          '[data-cognigy-webchat-root] [class*="webchat-teaser-message-root"]': {
            bottom: '125px !important',
          },
          '[data-cognigy-webchat-root] button[data-cognigy-webchat-toggle]': {
            bottom: '70px !important',
          },
        },
      }}
    />
  )
  // Define pages where Cognigy should load
  const cognigyPages = ['/kundeservice/internet/', '/kundeservice/faktura/']

  // Check if the current page is a Cognigy-specific page
  const isCognigyPage = cognigyPages.some(page => location.pathname.startsWith(page))

  return (
    <>
      {globalStyles}
      {/* Load CognigyChatInitializer only on Cognigy-specific pages */}
      {isCognigyPage && <CognigyChatInitializer />}
    </>
  )
}
